import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Difference } from './components/Difference';
import { BeforeAfter } from './components/BeforeAfter';
import { Pricing } from './components/Pricing';
import { HowItWorks } from './components/HowItWorks';
import { QuoteForm } from './components/QuoteForm';
import { SpanishBanner } from './components/SpanishBanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-ink font-body text-paper selection:bg-lime selection:text-ink" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <Difference data-id="element-5" />
        <BeforeAfter data-id="element-6" />
        <Pricing data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <QuoteForm data-id="element-9" />
        <SpanishBanner data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}